import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams  } from "react-router-dom";
import AdminLayout from "../layout/AdminLayout";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DownloadIcon from "@mui/icons-material/Download";
import { Button, Grid } from "@mui/material";
import agent from "../api/agent";
import { ScoreboardDto } from "../models/scoreboard";
import * as XLSX from "xlsx";

export default function ScoreBoard() {
  const { id : campaignId } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const urlGameType = searchParams.get("gameType");
  const campaignTitle = searchParams.get("campaignTitle");
  const [gameType, setGameType] = useState<number | null>(
    urlGameType ? parseInt(urlGameType) : null
  );
  const [data, setData] = useState<ScoreboardDto | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        if (!campaignId) return;
        var reversed = gameType === 5 ? true : false;
        const res = await agent.Games.scoreboardAll(campaignId, reversed);
        if (mounted) setData(res);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, [campaignId]);

  const handleOnExport = async () => {
    if (!data?.entries?.length) return;

    const rows = data.entries.map(e => ({
      "Sıra": e.rank,
      "İsim Soyad": e.name || "",
      "E-Posta": e.email || "",
      "Puan": e.points ?? 0,
    }));

    const workbook = XLSX.utils.book_new();
    const headers = ["Sıra", "İsim Soyad", "E-Posta", "Puan"];
    const worksheet = XLSX.utils.json_to_sheet(rows, { header: headers });

    headers.forEach((header, c) => {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c });
      if (worksheet[cellRef]) {
        worksheet[cellRef].s = { font: { bold: true } };
      }
    });

    worksheet["!cols"] = [{ wch: 8 }, { wch: 32 }, { wch: 30 }, { wch: 10 }];

    XLSX.utils.book_append_sheet(workbook, worksheet, "SkorTablosu");

    const campaignTitle = (searchParams?.get?.("campaignTitle") || "kampanya")
      .toLowerCase()
      .replace(/\s+/g, "-");
    XLSX.writeFile(workbook, `${campaignTitle}-skor-tablosu.xlsx`);
  };

  return (
    <>
      <AdminLayout title={`${campaignTitle || "Kampanya"} Skor Tablosu`}>
        <Grid container spacing={2} marginBottom={2} sx={{ justifyContent: "space-between" }}>
          <Grid item xs={6} sm={6} md={4}>
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate(`/campaigns/${campaignId}?gameType=${gameType}`)}
              sx={{ mb: 2, mr: 3 }}
            >
              Kampanyaya Dön
            </Button>
          </Grid>
          <Grid item xs={6} sm={6} md={4}>
            
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Button
              variant="contained"
              startIcon={<DownloadIcon />}
              color="success"
              onClick={handleOnExport}
            >
              Excel Çıktı Al
            </Button>
          </Grid>
        </Grid>        
        {loading && <div>Yükleniyor...</div>}
        {!loading && (
          <div style={{ maxWidth: 700 }}>
            <div style={{ marginBottom: 12, opacity: 0.8 }}>
              Toplam Oyuncu: {data?.total ?? 0}
            </div>

            <div
              style={{
                borderRadius: 12,
                overflow: "hidden",
                border: "1px solid rgba(255,255,255,0.15)",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "80px 1fr 1fr 120px",
                  padding: "10px 14px",
                  background: "rgba(255,255,255,0.06)",
                  fontWeight: 700,
                }}
              >
                <span>Sıra</span>
                <span>Ad</span>
                <span>E-Posta</span>
                <span style={{ textAlign: "right" }}>Puan</span>
              </div>

              <div
                style={{
                  maxHeight: "70vh",
                  overflow: "auto",
                  scrollbarWidth: "none",
                }}
                className="no-scrollbar"
              >
                {data?.entries?.map((row) => (
                  <div
                    key={row.rank}
                    style={{
                      display: "grid",
                      gridTemplateColumns: "80px 1fr 1fr 120px",
                      padding: "10px 14px",
                      background: row.isActive
                        ? "rgba(255,180,0,0.22)"
                        : "rgba(255,255,255,0.03)",
                      borderBottom: "1px solid rgba(255,255,255,0.06)",
                      fontWeight: row.isActive ? 700 : 500,
                    }}
                  >
                    <span>{row.rank}.</span>
                    <span
                      title={row.name}
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {row.name || "—"}
                    </span>
                    <span
                      title={row.email}
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {row.email || "—"}
                    </span>
                    <span style={{ textAlign: "right" }}>{row.points}</span>
                  </div>
                ))}
                {!data?.entries?.length && (
                  <div style={{ padding: 16, opacity: 0.7 }}>Henüz skor yok.</div>
                )}
              </div>
            </div>
          </div>
        )}
      </AdminLayout>
    </>
  );
}
